import React from 'react';
import axios from 'axios';
import { BrowserRouter as Router } from 'react-router-dom';

import { Alert, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import LoadingModal from './components/LoadingModal';
import Routes from './Routes';

const App = () => {

  const dispatch = useDispatch();

  const { snackbar } = useSelector(state => state);

  const closeSnackbar = React.useCallback(() => {
    dispatch({ type: 'CLOSE_SNACKBAR' });
  }, [dispatch]);

  React.useEffect(() => {
    axios.interceptors.request.use(function (config) {
      dispatch({ type: 'SHOW_LOADING', payload: true });

      return config;
    }, function (error) {
      return Promise.reject(new Error(error));
    });

    axios.interceptors.response.use(function (response) {
      dispatch({ type: 'SHOW_LOADING', payload: false });

      return response;
    }, function (error) {
      dispatch({ type: 'SHOW_LOADING', payload: false });

      return Promise.reject(error);
    });
  }, [dispatch]);

  return (
    <React.Fragment>
      <Router
        basename={process.env.PUBLIC_URL}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes />
      </Router>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={6000}
        onClose={closeSnackbar}
        open={snackbar.show}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}>
          {snackbar.message || "Erro ao processar requisição"}
        </Alert>
      </Snackbar>
      <LoadingModal />
    </React.Fragment>
  );
};

export default App;
